export const INVOICES_REQUEST = "INVOICES_REQUEST";
export const INVOICES_MONTH_SUMMARY_SUCCESS = "INVOICES_MONTH_SUMMARY_SUCCESS";
export const INVOICES_MONTH_CLIENTS_SUCCESS = "INVOICES_MONTH_CLIENTS_SUCCESS";
export const INVOICES_CLIENT_DETAIL_SUCCESS = "INVOICES_CLIENT_DETAIL_SUCCESS";
export const INVOICES_SET_ACTIVE_MONTH = "INVOICES_SET_ACTIVE_MONTH";
export const INVOICES_SET_ACTIVE_CLIENT = "INVOICES_SET_ACTIVE_CLIENT";
export const INVOICES_SET_ACTIVE_TAB = "INVOICES_SET_ACTIVE_TAB";
export const INVOICES_SET_TAB_NEW = "INVOICES_SET_TAB_NEW";
export const INVOICES_SET_TAB_DIRTY = "INVOICES_SET_TAB_DIRTY";
export const INVOICES_SET_TAB_SAVING = "INVOICES_SET_TAB_SAVING";
export const INVOICES_TAB_SAVE_SUCCESS = "INVOICES_TAB_SAVE_SUCCESS";
export const INVOICES_VALIDATION_ERROR = "INVOICES_VALIDATION_ERROR";
export const INVOICES_CLEAR_VALIDATION_ERROR = "INVOICES_CLEAR_VALIDATION_ERROR";
export const INVOICES_SYNC_CONFIG_RATES = "INVOICES_SYNC_CONFIG_RATES";
export const INVOICES_SYNC_STATUS = "INVOICES_SYNC_STATUS";
export const INVOICES_CLIENT_STATUS_UPDATE = "INVOICES_CLIENT_STATUS_UPDATE";
export const INVOICES_FAILURE = "INVOICES_FAILURE";
